import React, { useEffect } from 'react';

import {
	getModalToShow,
	Product,
	recordFirstModalShown,
	recordSecondModalShown,
	type StorageAdapter,
	UpgradeModalComponent,
} from '../../utils';
import { ConfluenceStandardOfferAIModal } from '../ConfluenceStandardOfferAIModal';
import { ConfluenceStandardOfferCalendarModal } from '../ConfluenceStandardOfferCalendarModal';

export const ConfluenceUpgradeFreePoolExperimentModalPreUpgrade = ({
	storageAdapter,
	experienceUrl,
	analyticsAttributes,
}: {
	analyticsAttributes: Record<string, any>;
	experienceUrl: string;
	storageAdapter: StorageAdapter;
}) => {
	// Determine which modal to show
	const modalToShow = getModalToShow(storageAdapter, Product.Confluence);

	// Record that the modal has been shown when component mounts
	useEffect(() => {
		if (!experienceUrl) {
			return;
		}

		if (modalToShow === UpgradeModalComponent.ConfluenceStandardOfferAIModal) {
			recordFirstModalShown(storageAdapter, Product.Confluence);
		} else if (modalToShow === UpgradeModalComponent.ConfluenceStandardOfferCalendarModal) {
			recordSecondModalShown(storageAdapter, Product.Confluence);
		}
	}, [modalToShow, storageAdapter, experienceUrl]);

	// If there is an issue fetching the experience url, do not render the modal
	if (!experienceUrl) {
		return null;
	}

	// Render the appropriate modal component
	switch (modalToShow) {
		case UpgradeModalComponent.ConfluenceStandardOfferAIModal:
			return (
				<ConfluenceStandardOfferAIModal
					analyticsAttributes={analyticsAttributes}
					experienceUrl={experienceUrl}
				/>
			);
		case UpgradeModalComponent.ConfluenceStandardOfferCalendarModal:
			return (
				<ConfluenceStandardOfferCalendarModal
					analyticsAttributes={analyticsAttributes}
					experienceUrl={experienceUrl}
				/>
			);
		case UpgradeModalComponent.None:
		default:
			return null;
	}
};
